import {
    RETRY_COUNT,
    STALE_TIME_RESOURCES,
} from "@impero-com/common/utils/query_client";

import {
    GetControlProgramsQueryResult,
    useGetControlPrograms,
    useGetControlProgramsSuspense,
} from "api/generated/control-program/control-program";

const queryOptions = {
    select: (response: GetControlProgramsQueryResult) => response.data,
    staleTime: STALE_TIME_RESOURCES,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    retry: RETRY_COUNT,
};

export const useControlProgramsQuery = (enabled = true) =>
    useGetControlPrograms(undefined, { query: { ...queryOptions, enabled } });

export const useControlProgramsSuspenseQuery = () =>
    useGetControlProgramsSuspense(undefined, { query: queryOptions });
